(() => {
  const SECTION_SELECTOR = '[data-dg-gold-allocation]';

  function parseValue(value) {
    const match = String(value || '').match(/-?\d+(?:\.\d+)?/);

    if (!match) {
      return null;
    }

    return {
      number: Number(match[0]),
      prefix: String(value).slice(0, match.index),
      suffix: String(value).slice(match.index + match[0].length)
    };
  }

  function animateNumber(element) {
    if (!element || element.dataset.counted === 'true') return;

    const parsed = parseValue(element.dataset.countTo);

    if (!parsed || !Number.isFinite(parsed.number)) {
      element.dataset.counted = 'true';
      return;
    }

    element.dataset.counted = 'true';

    const duration = 1600;
    const start = performance.now();

    function frame(now) {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = parsed.number * eased;

      const displayValue = Number.isInteger(parsed.number)
        ? Math.round(current)
        : current.toFixed(1);

      element.textContent =
        parsed.prefix +
        displayValue +
        parsed.suffix;

      if (progress < 1) {
        window.requestAnimationFrame(frame);
      } else {
        element.textContent =
          parsed.prefix +
          parsed.number +
          parsed.suffix;
      }
    }

    window.requestAnimationFrame(frame);
  }

  function initialize(section) {
    if (
      !section ||
      section.dataset.dgValuationReady === 'true'
    ) {
      return;
    }

    section.dataset.dgValuationReady = 'true';

    const numbers = Array.from(
      section.querySelectorAll('[data-count-to]')
    );

    if (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      numbers.forEach((number) => {
        number.textContent =
          number.dataset.countTo || number.textContent;

        number.dataset.counted = 'true';
      });

      return;
    }

    if (!('IntersectionObserver' in window)) {
      numbers.forEach(animateNumber);
      return;
    }

    const observer = new IntersectionObserver(
      (entries, instance) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          animateNumber(entry.target);
          instance.unobserve(entry.target);
        });
      },
      {
        threshold: 0.55
      }
    );

    numbers.forEach((number) => {
      observer.observe(number);
    });
  }

  function initializeAll(root = document) {
    root
      .querySelectorAll(SECTION_SELECTOR)
      .forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initializeAll()
    );
  } else {
    initializeAll();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeAll(event.target);
    }
  );
})();